"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataImport = void 0;
var DataImport;
(function (DataImport) {
    let ImportDataTypeValues;
    (function (ImportDataTypeValues) {
        ImportDataTypeValues["FogFacilitiesAndContacts"] = "FogFacilitiesAndContacts";
        ImportDataTypeValues["FogInspections"] = "FogInspections";
        ImportDataTypeValues["FogDevices"] = "FogDevices";
        ImportDataTypeValues["FogHaulers"] = "FogHaulers";
        ImportDataTypeValues["FogCleanings"] = "FogCleanings";
        ImportDataTypeValues["FogEvents"] = "FogEvents";
        ImportDataTypeValues["CccSitesAndHazards"] = "CccSitesAndHazards";
    })(ImportDataTypeValues = DataImport.ImportDataTypeValues || (DataImport.ImportDataTypeValues = {}));
    let ImportEntity;
    (function (ImportEntity) {
        ImportEntity["FogFacility"] = "FogFacility";
        ImportEntity["FogContact"] = "FogContact";
        ImportEntity["FogInspection"] = "FogInspection";
        ImportEntity["FogDevice"] = "FogDevice";
        ImportEntity["FogHauler"] = "FogHauler";
        ImportEntity["FogCleaning"] = "FogCleaning";
        ImportEntity["FogViolation"] = "FogViolation";
        ImportEntity["FogEvent"] = "FogEvent";
        ImportEntity["FogEquipment"] = "FogEquipment";
        ImportEntity["FogIncident"] = "FogIncident";
        ImportEntity["CccSite"] = "CccSite";
        ImportEntity["CccHazard"] = "CccHazard";
        ImportEntity["CccContact"] = "CccContact";
    })(ImportEntity = DataImport.ImportEntity || (DataImport.ImportEntity = {}));
    let SelfImportSteps;
    (function (SelfImportSteps) {
        SelfImportSteps["STEP1"] = "chooseDataType";
        SelfImportSteps["STEP2"] = "chooseAFile";
        SelfImportSteps["STEP3"] = "mapConfiguration";
        SelfImportSteps["STEP4"] = "preview";
        SelfImportSteps["STEP5"] = "results";
    })(SelfImportSteps = DataImport.SelfImportSteps || (DataImport.SelfImportSteps = {}));
    let ImportEntityPolicy;
    (function (ImportEntityPolicy) {
        ImportEntityPolicy["addAndUpdate"] = "AddAndUpdate";
        ImportEntityPolicy["addOnly"] = "AddOnly";
        ImportEntityPolicy["updateOnly"] = "UpdateOnly";
    })(ImportEntityPolicy = DataImport.ImportEntityPolicy || (DataImport.ImportEntityPolicy = {}));
    let FieldUpdatePolicy;
    (function (FieldUpdatePolicy) {
        FieldUpdatePolicy["alwaysUpdate"] = "AlwaysUpdate";
        FieldUpdatePolicy["updateOnlyWhenEmpty"] = "UpdateOnlyWhenEmpty";
        FieldUpdatePolicy["neverUpdate"] = "NeverUpdate";
    })(FieldUpdatePolicy = DataImport.FieldUpdatePolicy || (DataImport.FieldUpdatePolicy = {}));
})(DataImport = exports.DataImport || (exports.DataImport = {}));
//# sourceMappingURL=import.js.map